import { commitMutation } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'

import environment from '../../../environments/pom/Environment'

const mutation = graphql`
  mutation FireLoadsMarkAsDoneMutation($ids: [String]!, $companyId: ID!) {
    status: Me {
      Company(id: $companyId) {
        FireLoads(
          options: {
            filters: [
              {
                filterType: text
                operator: AND
                name: "id"
                conditions: [{ type: equals, value: $ids }]
              }
            ]
          }
        ) {
          markAsDone
        }
      }
    }
  }
`

export default (variables, accessToken, callBack, errorCallBack) => {
  commitMutation(environment(accessToken), {
    mutation,
    variables,
    onCompleted: callBack,
    onError: errorCallBack,
  })
}
